
  import { mapState } from 'vuex'
  import dataTable from '~/mixins/dataTable'
  export default {
    name: 'Theme2MissionMobileRewardHistoryPage',
    mixins: [dataTable],
    data() {
      return {
        openBottomFilter: false,
        api: 'activities/exchange-reward/getRewardHistories',
        page: 1,
        customFilters: {
          status: []
        }
      }
    },
    computed: {
      ...mapState({
        rewardHistories: state => state.activities['exchange-reward'].rewardHistories,
        missionsSettings: state => state.activities['mission-reward'].missionsSettings
      })
    },
    watch: {
      page(value) {
        this.customFilters.page = value
        this.API()
      }
    },
    mounted() {
      this.customFilters = {
        start_date: this.$dayjs().startOf('year').format('YYYY-MM-DD 00:00:00'),
        end_date: this.$dayjs().format('YYYY-MM-DD 23:59:59'),
        status: []
      }
      this.API()
    },
    methods: {
      async onSearch() {
        if (this.page > 1) {
          this.page = 1
        } else {
          await this.API()
        }
        this.openBottomFilter = false
      },
      convertToStatus(array) {
        // Define a mapping of numbers to their corresponding string values
        const statusMap = {
          1: this.tl('pending'),
          2: this.tl('success'),
          3: this.tl('rejected')
        }

        // Map each number in the array to its corresponding string value
        return array?.map(number => statusMap[number] || '')?.join(', ')
      },
      getStatusLabel(status) {
        switch (status) {
          case 1:
            return this.tl('pending')
          case 2:
            return this.tl('success')
          case 3:
            return this.tl('rejected')
          default:
            return '-'
        }
      },
      getStatusColor(status) {
        switch (status) {
          case 1:
            return 'primary'
          case 2:
            return 'success'
          case 3:
            return 'error'
          default:
            return 'grey'
        }
      },
      onChangeStartDate(date) {
        this.customFilters.start_date = date
      },
      onChangeEndDate(date) {
        this.customFilters.end_date = date
      }
    }
  }
